const frontendConfigApp={api_endpoint:"https://api.sharepass.com/v1",site_url:"https://view.sharepass.com/",app_url:"https://app.sharepass.com/",recaptcha_site_keys:"6LdWnageAAAAAHrmpd8M6B0cmgfOFuFGemTGUozQ"};
export default frontendConfigApp;
